import { Reducer } from 'redux';
import { InitialVehicleType, VehicleTypes } from './types';

const INITIAL_STATE: InitialVehicleType = {
  costPerAssistant: '',
  costPerCubicMeter: '',
  costPerKilometer: '',
  costPerOrder: '',
  costPerTon: '',
  createdAt: '',
  driverCost: '',
  packLoadWeight: '',
  payloadCapacity: '',
  updatedAt: '',
  vehicleType: 'VUC(Veículo Urbano de Carga)',
  vehicleTypeId: '',
};

const reducer: Reducer<InitialVehicleType> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case VehicleTypes.GET_VEHICLE_TYPE:
      return { ...state, ...action.payload };

    case VehicleTypes.CLEAR_VEHICLE_TYPE:
      // eslint-disable-next-line no-case-declarations
      const newState = { ...INITIAL_STATE };
      return newState;

    default:
      return state;
  }
};

export default reducer;
